import { useEffect } from 'react';

import { setCookie, getCookie } from 'cookies-next';

import postMarketingData from '@/services/postMarketingData'; // Adjust path as needed

/**
 * this is a bandaid solution to solve for marketing campaigns formatting
 * query strings incorrectly.
 */
const correctDuplicateQuestionMark = (url: string) => {
    const urlParts = url.split('?');
    if (urlParts.length <= 2) {
        return url;
    }

    let queryString = urlParts.slice(1).join('?');
    queryString = queryString.replace(/\?/g, '&');
    return `?${queryString}`;
};

// eslint-disable-next-line @typescript-eslint/require-await
const marketingSourceUrlParse = async () => {
    const queryString = window.location.search;
    const marketingParamsExist = queryString.includes('trans_id');

    if (marketingParamsExist) {
        const thirtyDaysFromNow = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);

        setCookie('marketing_source', correctDuplicateQuestionMark(queryString), { 
            expires: thirtyDaysFromNow,
            sameSite: 'lax',
            secure: process.env.NODE_ENV === 'production'
        });
    }
};

export const useMarketingSourceUrlParse = () => {
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        marketingSourceUrlParse();
    }, []);
};

// Helper to get marketing source cookie
export const getMarketingSourceCookie = (): string => {
    return getCookie('marketing_source') as string || '';
};

// Parse and save marketing data function
export const parseAndSaveMarketingData = async (
    marketingSourceCookie: string,
    leadId: string,
    baseUrl: string,
    headers: Record<string, string>,
    router: any,
    sessionId: string,
    transformMarketingSourceEnabled?: boolean
) => {
    // Remove the leading '?' if present
    const cleanCookie = marketingSourceCookie.startsWith('?') ? marketingSourceCookie.slice(1) : marketingSourceCookie;
    const urlParams = new URLSearchParams(cleanCookie);
    
    const marketingData: Record<string, unknown> = {
        session_id: sessionId,
        timestamp: Date.now(),
        domain: 'https://clearchoice.com',
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        pathname: router.pathname || '/',
    };

    // Process URL parameters - put trans_id as array of strings, others as direct values
    for (const [key, value] of urlParams.entries()) {
        if (key === 'trans_id') {
            marketingData[key] = [value]; 
        } else {
            marketingData[key] = value;
        }
    }

    // if the feature flag exists, add document.referrer to the marketingData payload, even if empty
    if (transformMarketingSourceEnabled) {
        marketingData.referrer = document.referrer;
    }

    const apiURL = `${baseUrl}/leads/${leadId}/marketing-data`;
    const payload = {
        leadId,
        marketingData,
    };

    return await postMarketingData(apiURL, payload, headers);
};